import fetch from '@/utils/fetch'

// 登录
export function login (data) {
  return fetch({
    url: '/user/login',
    method: 'post',
    data
  })
}

// 获取用户信息
export function getUserInfo () {
  return fetch({
    url: '/user/info',
    method: 'get'
  })
}

// 退出登录
export function logout () {
  return fetch({
    url: '/user/logout',
    method: 'delete'
  })
}

// 扫码登录
export function getPin (data) {
  return fetch({
    url: '/user/pin',
    method: 'post',
    data
  })
}
